"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var DoubleArrowLeft = function DoubleArrowLeft(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "DoubleArrowLeft"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "double-arrow-left"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.66,4.64a.77.77,0,0,1,0,1.06L5.18,10.16l4.48,4.48a.77.77,0,0,1,0,1.06.75.75,0,0,1-1.06,0l-5-5a.74.74,0,0,1,0-1.06l5-5A.74.74,0,0,1,9.66,4.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.91,4.64a.77.77,0,0,1,0,1.06l-4.48,4.46,4.48,4.48a.77.77,0,0,1,0,1.06.75.75,0,0,1-1.06,0l-5-5a.74.74,0,0,1,0-1.06l5-5A.74.74,0,0,1,15.91,4.64Z"
  }));
};

var _default = DoubleArrowLeft;
exports["default"] = _default;